/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout/Layout'
import Login from '@/views/Login/index'
import nprogress from '@/utils/nprogress'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/login',
            component: Login,
            name: 'login',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/login',
                keepAlive: false
            }
        },
        {
            path: '/user',
            component: Layout,
            name: 'Layout',
            redirect: '/user/staff',
            children: [{
                path: '/user/staff',
                component: () =>
                    import ('@/views/Login/personalCenter/staff.vue'),
                name: 'user/staff',
                meta: {
                    title: '身份认证',
                    hideNfHead: false,
                    NavMenuActive: '/user/staff',
                    keepAlive: false
                }
            }]
        },
        {
            path: '/register',
            component: () =>
                import ('@/views/Register/index.vue'),
            name: 'register',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/register',
                keepAlive: false
            }
        },
        {
            path: '/middle',
            component: () =>
                import ('@/views/Middle/index.vue'),
            name: 'middle',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/middle',
                keepAlive: false
            }
        },
        {
            path: '/auth/login',
            component: () =>
                import ('@/views/Auth/Login/index'),
            name: 'auth',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/Auth/Login/index',
                keepAlive: false
            }
        },
        {
            path: '/details',
            component: () =>
                import ('@/views/details.vue'),
            name: 'details',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/details',
                keepAlive: false
            }
        },
        {
            path: '/cookie',
            component: () =>
                import ('@/views/cookie.vue'),
            name: 'cookie',
            meta: {
                hideNfHead: true,
                NavMenuActive: '/cookie',
                keepAlive: false
            }
        },
        { path: '*', redirect: '/login' }
    ]
})

router.beforeEach(async(to, from, next) => {
    // 打开进度条
    nprogress.start()
    next()
})

router.afterEach(() => {
    setTimeout(() => {
            let _hmId = ''
            const hostname = window.location.hostname
            let _hmt = _hmt || []
            if (hostname.split('.')[2] === 'com') {
                _hmId = 'f5a3fb3e4c5f624466b13a2484d9285d'
            } else {
                _hmId = '7bf1f64de8850febf49367ddbe721eb3'
            };
            (function() {
                let hm = document.createElement('script')
                hm.src = 'https://hm.baidu.com/hm.js?' + _hmId
                let s = document.getElementsByTagName('script')[0]
                s.parentNode.insertBefore(hm, s)
            })()
        }, 0)
        // 在即将进入新的页面组件前，关闭掉进度条
    nprogress.done()
})

export default router